import { render, staticRenderFns } from "./shopsgoods.vue?vue&type=template&id=0c224d0e&"
import script from "./shopsgoods.vue?vue&type=script&lang=js&"
export * from "./shopsgoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports